import { render, staticRenderFns } from "./RapportagePerVraag.vue?vue&type=template&id=403668cc&scoped=true&"
import script from "./RapportagePerVraag.vue?vue&type=script&lang=js&"
export * from "./RapportagePerVraag.vue?vue&type=script&lang=js&"
import style0 from "./RapportagePerVraag.vue?vue&type=style&index=0&id=403668cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403668cc",
  null
  
)

export default component.exports